import { withRBAC } from "../../../rbac";
import { PayslipShow } from "./PayslipShow";

export const payrollSlips = {
  show: withRBAC(PayslipShow, "view_hr"),
};
